import { Button } from '@sravni/react-design-system/lib/Button';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';

import styles from './BonusInfoContent.module.scss';

export type BonusInfoContentProps = {
  onClose: () => void;
};

export const BonusInfoContent = (props: BonusInfoContentProps) => {
  const { onClose } = props;

  return (
    <Space direction="column" size={16}>
      <Text className={styles.text}>
        Под рублями мы понимаем бонусные рубли, которые зачисляются на бонусный счет и могут быть использованы
        пользователями в соответствии с правилами, 1 бонусный рубль&nbsp;=&nbsp;1&nbsp;рублю&nbsp;РФ
      </Text>
      <Card color="orange" size={16}>
        <Text>
          Акция с бонусом 500 ₽ доступна при получении первого займа в приложении и его погашении в срок без допущения
          просрочек
        </Text>
      </Card>
      <Link href="https://f.sravni.ru/cms/actions/mfo/action_mfo_june_2025.pdf" target="_blank">
        Полные условия акции
      </Link>
      <Button variant="primary" onClick={onClose}>
        Понятно
      </Button>
    </Space>
  );
};
